"use client";

import { cn } from "@/lib/utils";
import { HTMLProps, useRef, useEffect } from "react";

export default function IndeterminateCheckbox({
  indeterminate,
  className = "",
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate, rest.checked]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className={cn(
        "h-[18px] w-[18px] cursor-pointer accent-primary checked:text-white",
        className
      )}
      {...rest}
    />
  );
}
